module.exports = __webpack_public_path__ + "static/itach-hex-gray-8064d3828cc305714d053e0323c185c9.png";